import Map from './Map';

export default Map;
// export default React.lazy(() => import('./Map'));
